import { setting } from "./setting";

/** @type {import("vuex").Module} */
export const common = {
    namespaced: true,

    modules: {
        setting,
    },
};

export default common;
